<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-3">
        <oferta-crud />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OfertaCrud from "./OfertaCrud";
export default {
  name: "OfertaManagementPage",
  components: { OfertaCrud },
};
</script>

<style scoped></style>

